import { dataDatabase } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDatabase = /*#__PURE__*/createIcon(dataDatabase)
export default IconDatabase
